import styled from "@emotion/styled";

export const Container = styled.div`
  position: fixed;
  background-color: white;
  right: 20px;
  top: 88px;
  z-index: 100;

  height: calc(100vh - 88px - 20px);

  display: flex;
  flex-direction: column;
  width: 440px;
  box-sizing: border-box;

  padding: 40px 0;
  gap: 20px;

  border-radius: 16px;
  background: white;

  box-shadow: var(--alias-style-shadow-strong);

  .scroll-point {
    padding: 0 32px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    ::-webkit-scrollbar {
      background-color: white;
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: var(--component-color-fill-strong);
      border-radius: 100px;
    }
  }
  .resize-top {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 20px;
    cursor: s-resize;
  }
  .resize-down {
    position: absolute;
    display: flex;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 20px;
    cursor: s-resize;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  padding-bottom: 20px;
  margin: 0 40px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1 0 0;
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  /* align-self: stretch; */
  max-width: 100%;
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const Label = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 4px;
`;

export const TimeContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
`;

export const TimeDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 124px;
  height: 180px;
  align-items: flex-start;
  box-sizing: border-box;
  overflow-y: scroll;
  position: absolute;
  top: 48px;
  z-index: 101;

  border-radius: 0px 0px 8px 8px;
  background: white;

  box-shadow: var(--alias-style-shadow-strong);
`;

export const TimeDropdownItem = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  align-self: stretch;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
`;

export const MeetingRoomDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 200px;
  box-sizing: border-box;
  overflow-y: scroll;

  border-radius: 0px 0px 8px 8px;
  background: white;
  z-index: 101;

  box-shadow: var(--alias-style-shadow-strong);
  position: absolute;
  top: 48px;
`;

export const MeetingRoomDropdownItem = styled.div`
  position: relative;
  display: flex;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  cursor: pointer;

  &:hover {
    background: var(--component-color-fill-normal);
  }

  height: 62px;
  width: 100%;
  box-sizing: border-box;
`;

export const AttendeeItemContainer = styled.div`
  width: 360px;
  height: 44px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  box-sizing: border-box;
  position: relative;

  display: flex;
  border-radius: 4px;
  padding: 8px 12px;
  gap: 8px;

  .delete {
    display: none;
  }

  &:hover {
    .delete {
      display: flex;
      align-items: center;
    }
  }

  .interaction {
    opacity: 0;
    background-color: var(--alias-color-label-normal);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 4px;
    &:hover {
      opacity: 0.09;
    }
  }
`;

export const MemberListContainer = styled.div`
  background-color: white;
  z-index: 10;
  position: absolute;
  left: 1px;
  top: 48px;
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;

  width: 360px;
  box-sizing: border-box;

  border-radius: 0px 0px 8px 8px;
  background: white;
  box-shadow: var(--alias-style-shadow-strong);
`;

export const MemberListItem = styled.div`
  cursor: pointer;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 6px;
  align-self: stretch;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }

  .empty-img {
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;

    border-radius: 40px;
    background: var(--component-color-fill-normal);
  }

  img {
    width: 24px;
    height: 24px;
    border-radius: 40px;
    object-fit: cover;
  }
`;

export const ReservationOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
  flex: 1;
`;

export const RepeatConditionContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;

  border-radius: 8px;
  border: 1px solid var(--alias-color-line-normal);
`;

export const RepeatConditionItem = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`;
